import React from 'react';
import API_CALLS from 'API_CALLS/index';
import TemplatePage from 'global/templates/templatePage/index';



const QUERY = API_CALLS.BLOGS.QUERIES.allAndCount();
const QUERY_SINGLE = API_CALLS.BLOGS.QUERIES.single();
const QUERY_COUNT = API_CALLS.BLOGS.QUERIES.count();
const MUTATION_EDIT = API_CALLS.BLOGS.MUTATIONS.update();
const MUTATION_ADD = API_CALLS.BLOGS.MUTATIONS.create();
const QUERY_GET_USERS = API_CALLS.USERS.QUERIES.all(`email`);

const FORM_FIELDS = API_CALLS.BLOGS.FORM_FIELDS;
const LIST_HEADER_FIELDS = API_CALLS.BLOGS.LIST_HEADER_FIELDS;

const PREVIEW = API_CALLS.BLOGS.PREVIEW;

const API_CALLS_FULL = {
  QUERY,
  QUERY_SINGLE,
  QUERY_COUNT,
  MUTATION_EDIT,
  MUTATION_ADD,
  FORM_FIELDS,
  QUERY_GET_USERS,
  PREVIEW
};






const ValidateObject = (newObject, onSuccess, onFail)=>{
  if(newObject._id && !newObject.id) newObject.id = newObject._id;      
  //console.log("newObject");
  //console.log(newObject,"\n\n");
        
  Object.keys(newObject).map((key, index)=>{
    if(!newObject[key]) delete newObject[key];
  })  
  onSuccess(newObject);
  //onFail();      
};







const PAGES = () => [
  {
    "id": "BLOGS00",
    "Name":"Active",
    "PageName": "Active",
    "BasePage": "blogs",
    "Path": "active",
    "TITLE": "Active Blogs",
    "DATA_FIELD": "blogs",
    "GlobalStateVar": ["blogCountUpcomming"],
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "ACTIVE",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0,
      "dates": [
        {
          "field": "duration.startAt",
          "lte": `${Date.now()}`
        },
        {
          "field": "duration.endAt",
          "gt": `${Date.now()}`,
          "bool": false
        }
      ]
    },
    "NEWBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "EDITBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "DELETEBUTTON": {
      NAME: "BLOGS"
    },
    "CLONEBUTTON": {
      NAME: "BLOGS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("blogs/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Blog",
            "TITLE": "Blog", //TITLE OF SLIDE OUT
            "APINAME": "BLOGS",
            "NAME": "Blog",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  },
  {
    "id": "BLOGS01",
    "Name":"Upcoming",
    "PageName": "Upcoming",
    "BasePage": "blogs",
    "Path": "upcoming",
    "TITLE": "Upcoming Blogs",
    "DATA_FIELD": "blogs",
    "GlobalStateVar": ["blogCountUpcomming"],
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "ACTIVE",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0,
      "dates": [
        {
          "field": "duration.startAt",
          "gt": `${Date.now()}`
        }
      ]
    },
    "NEWBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "EDITBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "DELETEBUTTON": {
      NAME: "BLOGS"
    },
    "CLONEBUTTON": {
      NAME: "BLOGS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("blogs/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Blog",
            "TITLE": "Blog", //TITLE OF SLIDE OUT
            "APINAME": "BLOGS",
            "NAME": "Blog",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  },
  {
    "id": "BLOGS02",
    "Name":"Pending",
    "PageName": "Pending",
    "BasePage": "blogs",
    "Path": "pending",
    "TITLE": "Pending Blogs",
    "DATA_FIELD": "blogs",
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "PENDING",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0
    },
    "NEWBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "EDITBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "DELETEBUTTON": {
      NAME: "BLOGS"
    },
    "CLONEBUTTON": {
      NAME: "BLOGS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("blogs/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Blog",
            "TITLE": "Blog", //TITLE OF SLIDE OUT
            "APINAME": "BLOGS",
            "NAME": "Blog",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  },
  {
    "id": "BLOGS03",
    "Name":"History",
    "PageName": "History",
    "BasePage": "blogs",
    "Path": "history",
    "TITLE": "Blog History",
    "DATA_FIELD": "blogs",
    "API_CALLS": API_CALLS_FULL,
    "LIST_HEADER_FIELDS": LIST_HEADER_FIELDS,
    "VARIABLES": {
      "status": "NOTINACTIVE",
      "sortBy": "meta.createAt",
      "descending": false,
      "limit": 20,
      "offset": 0
    },
    "NEWBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "EDITBUTTON": {
      NAME: "BLOGS",
      TITLE: "Blog",
      FIELD: "blog"
    },
    "DELETEBUTTON": {
      NAME: "BLOGS"
    },
    "CLONEBUTTON": {
      NAME: "BLOGS",
      CONFIRMMESSAGE: "Are you sure you want to clone this? If so it be cloned into PENDING.",
      ONSUCCESS: ()=>{
        window.FlashMenuItem("blogs/pending");
      }
    },
    "BUTTONS": [
      {
        width: "110px",
        category: "Preview",
        buttonText: "View",
        className: "btn-color3",
        iconClass: "fas fa-eye",
        onClick: (obj)=>{
          window.GlobalUtil.triggerEvent("TemplateDBEvent", {
            "TYPE": "PREVIEW",
            "BUTTON_TITLE": "Blog",
            "TITLE": "Blog", //TITLE OF SLIDE OUT
            "APINAME": "BLOGS",
            "NAME": "Blog",
            "ID": obj._id
          }); 
        }
      }
    ],
    SHOWSELECTBOXES:true
  }
];





const Index = (props) => {
  //var {data} = props;
  var today = new Date();
  return (
     <TemplatePage
      ID={"AdminBlogs"}
      REPORTS={
        [
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfDay().getTime()}`
              }]
            },
            NAME: "blogCount",
            TITLE: "New Blogs Today"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfWeek().getTime()}`
              }]
            },
            NAME: "blogCount",
            TITLE: "Blogs this Week"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfMonth().getTime()}`
              }]
            },
            NAME: "blogCount",
            TITLE: "Blogs this Month"
          },
          {
            QUERY: QUERY_COUNT,
            VARIABLES: {
              "status": "NOTINACTIVE",
              "dates": [{
                field: "meta.createAt",
                gte: `${today.getStartOfYear().getTime()}`
              }]
            },
            NAME: "blogCount",
            TITLE: "Blogs this Year"
          }
        ]
      }
      REDIRECT={{
        "path": "/",
        "to": "active"
      }}
      PAGES={PAGES()}
      ValidateObject={ValidateObject}
    />
  );
}





export default Index;

export {PAGES};   

      
